module.exports = __webpack_public_path__ + "static/media/search-reports-1.36032d53.png";